import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import * as fromQuoteListState from './quote-list.reducer';
import { QuoteListEffects } from './quote-list.effects';

@NgModule({
	imports: [
		StoreModule.forFeature(
			fromQuoteListState.quoteListFeatureKey,
			fromQuoteListState.reducer
		),
		EffectsModule.forFeature([QuoteListEffects]),
	],
})
export class QuoteListStateModule {}
